export default function NotFound() {
  return (
    <div className="text-black">
      Sorry, the page you are trying to access does not exist
    </div>
  );
}
